export default __webpack_public_path__ + "static/media/Group9215.089b4442.svg";